<template>
  <div class="flex flex-col gap-6">
    <div class="flex justify-end gap-4">
      <button
        class="text-text-inactive hover:text-text-active transition-colors"
        @click="$emit('minimize')"
      >
        <Icon icon="Status-Wireframe-Collapse" class="size-6" />
      </button>
      <button
        class="text-text-inactive hover:text-text-active transition-colors"
        @click="$emit('close')"
      >
        <Icon icon="Status-Wireframe-Close" class="size-6" />
      </button>
    </div>

    <div class="flex flex-col gap-2 mt-4 w-145">
      <rocketProgress v-model="progress" />
    </div>
    <div class="text-center space-y-2 mt-4">
      <p class="text-m-medium text-text-body-default">
        {{ $t('setting.about.update.checkUpdateDialog.updatingText') }}
        <span class="text-brand-blue1">{{ currentSize }}</span
        >MB/{{ totalSize }}MB
      </p>
      <p class="text-s-medium text-text-explanatory-default">
        {{ $t('setting.about.update.checkUpdateDialog.updatingTipText') }}
      </p>
    </div>
  </div>
</template>

<script setup lang="ts">
  import { computed } from 'vue'
  import { Icon } from '@rapoo/element'
  import rocketProgress from '@/components/rocketProgress/index.vue'

  const emit = defineEmits<{
    (e: 'close'): void
    (e: 'minimize'): void
    (e: 'finish'): void
  }>()

  import { useUpdateStore } from '@/stores'
  import { storeToRefs } from 'pinia'
  const updateStore = useUpdateStore()
  const { process } = storeToRefs(updateStore)
  const progress = computed(() => process.value?.percent || 0)
  const currentSize = computed(() => {
    const bytes = process.value?.transferred || 0
    return (bytes / 1024 / 1024).toFixed(2)
  })

  const totalSize = computed(() => {
    const bytes = process.value?.total || 0
    return (bytes / 1024 / 1024).toFixed(2)
  })
</script>
